import React, { useEffect, useState } from "react";
import Handler from "../../../Helpers/Handler";

// Cascading Brand -> Model -> Variant picker. There is no flat "all active
// variants" endpoint (variantActiveList is scoped to one modelId, and
// modelActiveList to one brandId - see VehicleRouter.js), so this walks the
// same catalog tree BrandDetail/ModelDetail already drill into: brands of
// the given brandType, that brand's models, that model's variants. Only
// active (status:true) records are offered, matching what
// carVariantIdValidator/bikeVariantIdValidator will actually accept.
const VariantPicker = ({ brandType, onSelect }) => {
    const [brands, setBrands] = useState([]);
    const [models, setModels] = useState([]);
    const [variants, setVariants] = useState([]);
    const [brandId, setBrandId] = useState("");
    const [modelId, setModelId] = useState("");
    const [variantId, setVariantId] = useState("");
    const [loadingBrands, setLoadingBrands] = useState(true);
    const [loadingModels, setLoadingModels] = useState(false);
    const [loadingVariants, setLoadingVariants] = useState(false);

    useEffect(() => {
        (async () => {
            setLoadingBrands(true);
            const response = await Handler({ method: "GET", url: "/staff/vehicle/brand/active", params: { brandType } });
            setBrands(response?.success ? response?.data?.data || [] : []);
            setLoadingBrands(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brandType]);

    const onBrandChange = async (value) => {
        setBrandId(value);
        setModelId("");
        setVariantId("");
        setModels([]);
        setVariants([]);
        onSelect?.("");
        if (!value) return;
        setLoadingModels(true);
        const response = await Handler({ method: "GET", url: `/staff/vehicle/brand/${value}/model/active` });
        setModels(response?.success ? response?.data?.data || [] : []);
        setLoadingModels(false);
    };

    const onModelChange = async (value) => {
        setModelId(value);
        setVariantId("");
        setVariants([]);
        onSelect?.("");
        if (!value) return;
        setLoadingVariants(true);
        const response = await Handler({ method: "GET", url: `/staff/vehicle/model/${value}/variant/active` });
        setVariants(response?.success ? response?.data?.data || [] : []);
        setLoadingVariants(false);
    };

    const onVariantChange = (value) => {
        setVariantId(value);
        onSelect?.(value);
    };

    return (
        <div className="row g-3">
            <div className="col-12 col-md-4">
                <label className="form-label">Brand</label>
                <select className="form-select" value={brandId} onChange={(e) => onBrandChange(e.target.value)} disabled={loadingBrands}>
                    <option value="">{loadingBrands ? "Loading..." : "Select brand"}</option>
                    {brands.map((b) => (<option key={b.brandId} value={b.brandId}>{b.brand}</option>))}
                </select>
            </div>
            <div className="col-12 col-md-4">
                <label className="form-label">Model</label>
                <select className="form-select" value={modelId} onChange={(e) => onModelChange(e.target.value)} disabled={!brandId || loadingModels}>
                    <option value="">{loadingModels ? "Loading..." : brandId ? "Select model" : "Select a brand first"}</option>
                    {models.map((m) => (<option key={m.modelId} value={m.modelId}>{m.modelName}</option>))}
                </select>
                {brandId && !loadingModels && !models.length ? <div className="form-text text-danger">No active models under this brand.</div> : null}
            </div>
            <div className="col-12 col-md-4">
                <label className="form-label">Variant</label>
                <select className="form-select" value={variantId} onChange={(e) => onVariantChange(e.target.value)} disabled={!modelId || loadingVariants}>
                    <option value="">{loadingVariants ? "Loading..." : modelId ? "Select variant" : "Select a model first"}</option>
                    {variants.map((v) => (<option key={v.variantId} value={v.variantId}>{v.variantName}</option>))}
                </select>
                {modelId && !loadingVariants && !variants.length ? <div className="form-text text-danger">No active variants under this model.</div> : null}
            </div>
        </div>
    );
};

export default VariantPicker;
